<template>
  <section>
    <ion-header v-show="showing">
      <ion-toolbar>
        <ion-buttons slot="start">
          <img :src="logoAsset" :style="{height: '60px'}" alt="{{title}}" class="contain" />
        </ion-buttons>
        <ion-title size="small">
          <SelectCompany/>
        </ion-title>
        <ion-buttons slot="end">
          <ion-fab-button 
            v-if="false"
            @click="syncOffline"
            :disabled="offline || synchronizing" 
            class="fab-sync" 
            size="small" 
            fill="celar"
            :color="colorSync">
            <ion-icon :icon="sync"></ion-icon>
            <ion-badge :class="'badge-sync'" :color="colorSync">
              {{ computedLastSync }}
            </ion-badge>
          </ion-fab-button>
          <ion-avatar @click="setOpen(true)">
            <ion-img v-if="user && user.avatar" :src="user.avatar.imageUrl"></ion-img>
            <ion-img v-else-if="user && user.email" :src="gravatarUser"></ion-img>
            <Notification :justBadge="true"/>
          </ion-avatar>
        </ion-buttons>
      </ion-toolbar>

      <ion-row v-if="computedLoading || computedErpOff" >
        <ion-col v-if="computedLoading" class="ion-text-center">
          <ion-spinner name="dots" style="margin: 0 auto;"></ion-spinner>
        </ion-col>
        <ion-col v-if="computedErpOff" style="display: flex; justify-content: center;">
          <ion-chip color="danger">
            <ion-icon :icon="cloudOffline"></ion-icon>
            <ion-label>Protheus offline! Comunicação indisponível.</ion-label>
            <ion-icon :icon="close" @click="erpOff = false"></ion-icon>
          </ion-chip>
        </ion-col>
      </ion-row>
    
      <ion-row v-if="offline" class="toolbar-offline">
        <ion-col size="12">
          <ion-button color="danger" size="small" expand="full">
            <ion-icon :icon="cloudOffline"></ion-icon>&nbsp; Trabalhando off-line! 
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-if="synchronizing" class="toolbar-offline sync">
        <ion-col size="12">
          <ion-button color="primary" size="small" expand="full">
            <ion-icon :icon="syncCircleOutline"></ion-icon>&nbsp; Sincronizando dados off-line.
          </ion-button>
          <ion-progress-bar color="primary" type="indeterminate"></ion-progress-bar>
        </ion-col>
      </ion-row>
      
      <ion-modal :is-open="isOpenRef" @didDismiss="setOpen(false)">
        <ModalUser />
      </ion-modal>
    </ion-header>
  
    <ion-list class="list-search" v-if="showing && showingSearch && (searching.stats || searchingAsync.stats)">
      <ion-item class="ion-item-search" lines="none">
        <!-- <ion-input placeholder="Buscar" clear-input/> -->
        <ion-icon :icon="search"/>
        <v-text-field-algolia 
          v-if="searching.stats"
          :index="searching.index" 
          :delay="750"
          :placeholder="'Buscar'"
          :handler="searching.handler"
          :facetFilters="searching.filters"
          :attributesToHighlight="searching.attributesToHighlight"
          >
        </v-text-field-algolia>
        <v-text-field-async 
          v-else-if="searchingAsync.stats"
          :placeholder="'Buscar'"
          :delay="750"
          :register="searchingAsync.register" 
          :collection="searchingAsync.collection" 
          :handler="searchingAsync.handler"
          :handlerLoading="searchingAsync.handlerLoading"
          :fieldsToSearch="searchingAsync.fieldsToSearch"
          >
        </v-text-field-async>
      </ion-item>

      <ion-button 
        @click="toggleFiltering({open: true})"
        size="small"
        shape="round" 
        expand="full"
        fill="solid"
        :color="filterHeader.hasFilter ? 'success' : 'medium'"
        :style="{margin: '5px', height: '30px'}"
        >
        <ion-icon size="small" :icon="filterOutline" :style="{marginRight: '5px'}"></ion-icon>
        Filtros
      </ion-button>
    </ion-list> 
    
  </section> 
</template>

<script>
import crypto from 'crypto'
import {ellipsisVertical} from "ionicons/icons";
import ModalUser from "./ModalUser.vue";
import SelectCompany from "../Templates/SelectCompany.vue";
import Notification from "../Templates/Notification.vue"
// import FilterButton from "../FilterButton.vue"
import {
  IonHeader,
  IonList,
  IonItem,
  IonSpinner,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonChip,
  IonLabel,
  IonFabButton,
  IonButton,
  IonModal,
  IonProgressBar,
  IonAvatar,
  IonBadge,
  IonRow,
  IonCol,
  IonImg,
  IonIcon
} from "@ionic/vue";
import { search, filter, chevronUp, cloudOffline, sync, syncCircleOutline, filterOutline, close } from 'ionicons/icons'

import {createNamespacedHelpers, mapState, mapActions, mapMutations} from "vuex";
import {defineComponent, ref} from "vue";
import VTextFieldAlgolia from '../VTextFieldAlgolia.vue';
import VTextFieldAsync from '../VTextFieldAsync.vue';
const { mapState:authState } = createNamespacedHelpers('auth')
const { mapState:registersState, mapActions:registersActions } = createNamespacedHelpers("registers")
export default defineComponent({
  name: "Loading",
  components: {
    IonHeader,
    IonBadge,
    IonList,
    IonItem,
    IonToolbar,
    IonTitle,
    IonProgressBar,
    IonButtons,
    IonButton,
    IonFabButton,
    IonChip,
    IonLabel,
    // IonInput,
    IonRow,
    IonCol,
    IonAvatar,
    IonModal,
    IonImg, 
    ModalUser,
    SelectCompany,
    Notification,
    IonIcon,
    IonSpinner,
    VTextFieldAlgolia,
    VTextFieldAsync
  },
  props: ["title", "have_menu"],
  data() {
    return {
      today: new Date(),
      logoAsset: '',
      erpOff: false,
      loadingERP: false,
      interval: null
    }
  },
  computed: {
    ...authState(['user']),
    ...mapState(["loading", "searching", "searchingAsync", "offline", "synchronizing", 'syncable', "lastSync", "companySelected", 'filterHeader']),
    ...registersState(['registerActive']),
    showing() {
      return !this.$route.meta.public && !this.$route.path.includes('cadastrar') && !this.$route.path.includes('detalhes') && !this.$route.path.includes('dashboard/');
    },
    showingSearch() {
      return this.showing && !this.$route.path.includes('reports');
    },
    menu() {
      return [];
    },
    gravatarUser() {
      return this.getGravatar()
    },
    colorSync() {
      let colorSync = 'warning'
      if (typeof this.computedMinutes !== 'number' || this.computedMinutes > (60*24) || this.computedMinutes < 0) { 
        colorSync = 'danger'
      } else if (this.computedMinutes < 60) {
        colorSync = 'success'
      } else if (this.computedMinutes < (60*24)) {
        colorSync = 'primary'
      }
      return colorSync
    },
    computedLastSyncData() {
      return this.lastSync
    },
    lastSyncRegister() {
      if (!this.computedLastSyncData) return
      const lastSyncRegister = this.computedLastSyncData
      if (!lastSyncRegister) return null
      return lastSyncRegister
    },
    computedMinutes() {
      if (typeof this.lastSyncRegister === 'null' || this.lastSyncRegister === NaN) return -1
      const diffMs = (this.today.getTime() - (new Date(this.lastSyncRegister)).getTime())
      const minutes = Math.round(((diffMs / 1000) / 60))
      return minutes
    },
    computedLastSync() {
      if (isNaN(this.computedMinutes) || this.computedMinutes == 0) {
        return ''
      } else if (this.computedMinutes < 60) {
        return `${this.computedMinutes}m`
      } else if (this.computedMinutes < (60*24)) {
        return `${Math.round(this.computedMinutes/60)}h`
      } else {
        return `${Math.round(this.computedMinutes/(60*24))}d`
      }
    },
    computedErpOff() {
      return this.erpOff
    },
    computedLoading() {
      return this.loadingERP
    }
  },
  watch: {
    lastSync(newValue) {
    },
    filterHeader: {
      handler: function ({open, hasFilter}) {
        this.openFilter = open
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['toggleSearching', 'toggleFiltering']),
    ...mapMutations(['setLoading']),
    ...registersActions(['syncOffline', 'getApi']),
    getGravatar() {
      let hash = crypto
        .createHash("md5")
        .update(this.user.email || "")
        .digest("hex");
      return `https://www.gravatar.com/avatar/${hash}`;
    },
    allowed(meta) {
      let allowed = true;
      if (meta.requireClaim && (!this.$appConfig.claims || !this.$appConfig.claims[meta.requireClaim])) {
        allowed = false;
      }
      return allowed;
    },
  },
  setup() {
    const isOpenRef = ref(false);
    const setOpen = (state) => {
      isOpenRef.value = state;
    };
    const data = {content: "New Content"};
    return {ellipsisVertical, syncCircleOutline, isOpenRef, setOpen, data, search, filter, chevronUp, cloudOffline, sync, filterOutline, close};
  },
  async created() {
    this.today = new Date()
    setInterval(() => 
       this.today = new Date()
    , 6000)

    let theme = window.matchMedia('(prefers-color-scheme: dark)')

    this.logoAsset = theme.matches ? require("@/assets/logo_mini.png") : require("@/assets/logo_mini_dark.png")

    theme.addListener((mediaQuery) => {
      this.logoAsset = mediaQuery.matches ? require("@/assets/logo_mini.png") : require("@/assets/logo_mini_dark.png")
    })

    this.logoAsset = this.companySelected?.configs?.logoMobile || this.logoAsset

    const timeout = this.companySelected?.configs?.apiRest[this.companySelected?.M0_CODFIL]?.timeout || 12000
    const tenantId = this.companySelected?.groupCompany
    this.loadingERP = true
    try {
      const result = await this.getApi({timeout, url: '/protheus/', options: {noToast: true}, tenantId})
      if (result?.status === 500 || result?.status === 400) {
        this.erpOff = true
      } else {
        this.erpOff = false
      }
    } catch (error) {
      this.erpOff = true
    }
    this.loadingERP = false
    this.interval = setInterval(async () => {
      try {
        const result = await this.getApi({timeout, url: '/protheus/', options: {noToast: true}, tenantId})
        if (result?.status === 500 || result?.status === 400) {
          this.erpOff = true
        } else {
          this.erpOff = false
        }
      } catch (error) {
        this.erpOff = true
      }
    }, 60000)
  },
  beforeUnmount() {
    clearInterval(this.interval)
  }
});
</script>

<style>
  /* ion-header {
    height: 5.2em;
  } */
  ion-avatar {
    padding: .6em;
  }
  ion-avatar ion-img {
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
  }
  ion-title {
    padding: 0;
  }
  .toolbar-offline * {
    padding: 0;
    margin: 0;
  }
  .toolbar-offline.sync ion-button{
    font-size: .6em;
  }
  /* .toolbar-offline ion-button {
    padding: 0;
    margin: 0;
  } */

  .fab-sync {
    --box-shadow: unset;
    position: relative;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    margin: .25em;
  }

  .badge-sync{
    z-index: 100;
    font-size: .65em;
    position: absolute;
    bottom: .01em;
    right: .15em;
  }

  .ion-item-search {
    /* background-color: unset; */
    margin: .2em;
    /* border-radius: 25px; */
    border-color: rgba(0, 0, 0, 0.2);
    border-width: thin;
    border-style: solid;
    border-radius: 25px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    font-family: Open Sans,sans-serif!important;
    color: rgba(0, 0, 0, 0.671);
  }

  ion-header {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }

  .list-search {
    /* position: absolute; */
    background: transparent;
    /* top: 4em; */
    z-index: 11;
    width: 100%;
    padding: 2px 0px 0px 0px!important;
    /* margin: .2em 0em 0em 0em; */
  }

  .list-search ion-item ion-input input {
    padding: 0px!important;
  }

</style>
